import { validString } from "Components/shared/helpers/validations";
import * as Yup from "yup";
import { isEmpty } from "lodash";
import moment from "moment";

export const fullName = Yup.string().min(3).max(100);

export const email = Yup.string().email();

export const dialCode = Yup.string()
  .matches(/^[0-9]+$/)
  .min(1)
  .max(7);

export const phoneNumber = Yup.string()
  .matches(/^[0-9]+$/)
  .min(4)
  .max(12);

export const date = Yup.string().matches(
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/,
);

export const idType = Yup.mixed().oneOf(["PASSPORT", "NRIC", "FOREIGN_ID"]);

export const passport = Yup.string()
  .matches(/^[a-zA-Z0-9]+$/)
  .min(5);

export const postcode = Yup.string()
  .matches(/^[0-9]+$/)
  .min(5)
  .max(10);

export const nric = Yup.string().matches(
  /^((([[0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01]))([0-9]{2})([0-9]{4}){1})$/i,
);

export const idNumber = Yup.string()
  .when("idType", { is: "PASSPORT", then: passport })
  .when("idType", { is: "NRIC", then: nric });

// Must contain between 6-12 alphanumeric characters, 1 uppercase and 1 special characters
export const password = Yup.string()
  .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-+_!@#$%^&*.,?])/)
  .min(6)
  .max(12);

export const gender = Yup.mixed().oneOf(["MALE", "FEMALE"]);

export const addressLine = Yup.string().max(100);

export const fullContact = Yup.object({
  dialCode: dialCode.required(),
  number: phoneNumber.required(),
});

export const workingHours = Yup.object({
  day: Yup.string().required(),
  isChecked: Yup.boolean().required(),
  openingTime: Yup.object()
    .test("openingTimeRequired", "openingTimeRequired", function (value) {
      const { isChecked } = this.parent;

      // if it is not checked, this is not required
      if (!isChecked) return true;

      // if there is a value and it is checked, it passes validation
      if (value) return true;

      return false;
    })
    .nullable(),
  closingTime: Yup.object()
    .test("beforeOpeningTime", "beforeOpeningTime", function (value) {
      const { openingTime, isChecked } = this.parent;

      // if it is not checked, this is not required
      if (!isChecked) return true;

      // if there is no value, it fails validation
      if (!value) return false;
      if (!moment(value).isValid()) return false;

      // compare closingTime with openingTime
      // -> must be after
      const isAfterOpening = moment(value).isAfter(moment(openingTime));

      if (isAfterOpening) return true;
      return false;
    })
    .nullable(),

  // openingTime: Yup.object()
  //   .when("isChecked", {
  //     is: (isChecked) => isChecked == true,
  //     then: Yup.object().required("Opening time is required"),
  //   })
  //   .nullable(),
  // if closingTime < openingTime, invalidate it
  // closingTime: Yup.object()
  //   .when("isChecked", {
  //     is: (isChecked) => isChecked == true,
  //     then: Yup.object()
  //       .test("beforeOpeningTime", "beforeOpeningTime", function (value) {
  //         const { openingTime } = this.parent;
  //         return moment(value)?.isAfter(moment(openingTime));
  //       })
  //       .required("Closing time is required"),
  //   })
  //   .nullable(),
});

export const city = Yup.string().max(50);

export const state = Yup.string().max(50);

export const country = Yup.string().matches(/^[a-zA-Z]{2}$/i);

const prefixRegex = /^(BOX|OP$)/;

export const prefix = Yup.string()
  .matches(/^[A-Z]{3}/)
  .min(3)
  .max(3)
  .test("prefixNotAllowed", "prefixNotAllowed", (value) => {
    if (typeof value == "string") return !prefixRegex.test(value);
    else return false;
  });
